// extracted by mini-css-extract-plugin
export default {"overlay":"Dialogs_overlay__MQl32","dialog":"Dialogs_dialog__YHMMz","title":"Dialogs_title__J49XZ","body":"Dialogs_body__L7IA-","actions":"Dialogs_actions__rpAb5"};